<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Factureren"
      @next-step="$router.push({ name: 'printProductSecuredSAInvoice' })"
      @prev-step="$router.push({ name: 'printProductSecuredSA' })"
    ></next-prev-menu>

    <deliver-pickup
      :orderDetails="orderDetails"
      :shop="shop"
      :dates="dates"
      :secure="orderDetails.secure"
      @updateOrder="updateOrder"
    ></deliver-pickup>
  </div>
</template>

<script>
import { usePrintProductSecuredSAStore } from '@/features/printProductSecuredSA/PrintProductSecuredSA.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import DeliverPickup from '@/components/DeliverPickup.vue'
import { mapStores } from 'pinia'

export default {
  data() {
    return {}
  },
  mixins: [OrderMixin],
  components: {
    NextPrevMenu,
    DeliverPickup
  },
  methods: {
    updateOrder(val) {
      this.printProductSecuredSAStore.updateOrderDetails(val[0], val[1])
    }
  },
  computed: {
    ...mapStores(usePrintProductSecuredSAStore),
    orderDetails() {
      return this.printProductSecuredSAStore.orderDetails
    },
    shop() {
      return this.printProductSecuredSAStore.shop
    },
    dates() {
      return this.printProductSecuredSAStore.dates
    }
  },
  created() {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.card {
  //height: 590px;
}
</style>
